import React, { useMemo, memo } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import {
  isShippingWithPickupAndDelivery,
  isShippingTypePickUp,
} from '@utils/shop';
import Toggle from '../Toggle';
import WithPickupToggle from '../WithPickupToggle';
import { Delivery, Pickup } from './Information';
import { Container, Text } from './components';
import messages from './messages';

const PickupToggle = ({
  deliveryType,
  plusSettings,
  intl: { formatMessage },
}) => {
  const showToggle = useMemo(
    () => isShippingWithPickupAndDelivery(deliveryType),
    [deliveryType],
  );
  const onlyPickup = useMemo(() => isShippingTypePickUp(deliveryType), [
    deliveryType,
  ]);

  return (
    <Container>
      <WithPickupToggle>
        {({ onClick, loading, info, isPickup, origin }) => (
          <>
            {showToggle && (
              <Toggle onClick={onClick} isPickup={isPickup} origin={origin} />
            )}
            {!showToggle && onlyPickup && (
              <Text>{formatMessage(messages.onlyPickup)}</Text>
            )}
            {isPickup ? (
              <Pickup loading={loading} info={info.pickup} />
            ) : (
              <Delivery
                loading={loading}
                info={info.delivery}
                plusSettings={plusSettings}
              />
            )}
          </>
        )}
      </WithPickupToggle>
    </Container>
  );
};

PickupToggle.propTypes = {
  intl: intlShape.isRequired,
  deliveryType: PropTypes.oneOf(Object.values(SHOP_DELIVERY_TYPE)).isRequired,
  plusSettings: PropTypes.object,
};

export default memo(injectIntl(PickupToggle));
